import React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import ContainerForClinicUser from "./ContainerForClinicUser";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectClinicUserList,
  selectLoading,
  selectSortConfig,
  selectClinicCurrentPage,
  selectClinicTotalPages,
} from "store/ClinicStore/selectors";
import {
  goToPageClinicUsers,
  changeSortOfClinicUserList,
} from "store/ClinicStore/actions";
import { StatusENUM } from "types/common";

const ClinicListContainer: React.FC<{
  disableUser: (userId: string, status?: StatusENUM) => void;
  editUser: (userId: string) => void;
  resendInvitation: (email: string,role:any) => void;
}> = ({ disableUser, editUser, resendInvitation }) => {
  const dispatch = useAppDispatch();
  const clinicUserList = useAppSelector(selectClinicUserList);
  const currentPage = useAppSelector(selectClinicCurrentPage);
  const totalPages = useAppSelector(selectClinicTotalPages);
  const sortConfig = useAppSelector(selectSortConfig);
  const isLoading = useAppSelector(selectLoading);

  const onClick = (sortBy: string) => {
    dispatch(changeSortOfClinicUserList(sortBy));
  };

  const onPageChange = React.useCallback(
    (_ev: React.ChangeEvent<unknown>, page: number) => {
      dispatch(goToPageClinicUsers(page));
    },
    [dispatch]
  );

  return isLoading ? (
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginTop: "40px",
    }}
  >
    <CircularProgress color="inherit" size={50} />
  </div>
  ) : (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      <ContainerForClinicUser
        clinicUserList={clinicUserList}
        onClick={onClick}
        sortConfig={sortConfig}
        loading={isLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        editUser={editUser}
        disableUser={disableUser}
        resendInvitation={resendInvitation}
      />
    </div>
  );
};

export default ClinicListContainer;
